'use client';

import { useClerk, useUser } from '@clerk/clerk-react';
import { useNavigate } from '@tanstack/react-router';

import { ThemeToggle } from '@/components/ui/ThemeToggle';
import { isStaffEmail } from '@/lib/auth/staff';

import { Footer } from './Footer';
import { Navigation } from './Navigation';

interface DashboardLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
}

export default function DashboardLayout({
  children,
  isLoading = false,
}: DashboardLayoutProps) {
  const { user } = useUser();
  const { signOut } = useClerk();
  const navigate = useNavigate();
  const showAdminNav = isStaffEmail(user?.primaryEmailAddress?.emailAddress);

  const handleSignOut = async () => {
    await signOut();
    await navigate({ to: '/', search: {} });
  };

  return (
    <div className="bg-background flex min-h-screen flex-col">
      <Navigation
        isLoading={isLoading}
        isSignedIn
        mode="dashboard"
        showAdminNav={showAdminNav}
        onSignOut={handleSignOut}
      />
      {/* flex-1 makes the main area grow to fill the viewport so the footer stays
          pinned to the bottom even when a page (e.g. the setup state) is short. */}
      <main className="flex-1 pt-16">{children}</main>
      <Footer isLoading={isLoading} />
      <ThemeToggle />
    </div>
  );
}
